"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CardContainer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CardContainer, _React$PureComponent);

  var _super = _createSuper(CardContainer);

  function CardContainer() {
    _classCallCheck(this, CardContainer);

    return _super.apply(this, arguments);
  }

  _createClass(CardContainer, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var cardClasses = 'mb18 ';

      if (!props.fullWidthCards) {
        cardClasses += "col col--12 col--".concat(this.props.cardColSize, "-ml");
      } else {
        cardClasses += 'border-b border--darken10';
      }

      var containerClasses = (0, _classnames.default)('', {
        'grid grid--gut36': !props.fullWidthCards
      });
      var renderedCards = props.cards.map(function (card, index) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: index,
          className: cardClasses
        }, card);
      });
      return /*#__PURE__*/_react.default.createElement("div", null, props.title && props.path && /*#__PURE__*/_react.default.createElement("a", {
        href: props.path,
        className: "unprose mb18 block color-blue-on-hover"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "txt-bold unprose",
        id: props.path.split('#')[1]
      }, props.title, ' ', /*#__PURE__*/_react.default.createElement("span", {
        "data-swiftype-index": "false"
      }, "(", props.cards.length, ")"))), /*#__PURE__*/_react.default.createElement("div", {
        className: containerClasses
      }, renderedCards));
    }
  }]);

  return CardContainer;
}(_react.default.PureComponent);

CardContainer.defaultProps = {
  cardColSize: 6,
  fullWidthCards: false
};
CardContainer.propTypes = {
  title: _propTypes.default.string,
  path: _propTypes.default.string,
  fullWidthCards: _propTypes.default.bool,
  cards: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,
  cardColSize: _propTypes.default.oneOf([1, 2, 3, 4, 5, 6])
};
var _default = CardContainer;
exports.default = _default;